import React from 'react';

function InputLabel({ label, small }) {
  return (
    <small className={`${small ? 'text-sm' : 'text-xs'} font-sf-regular capitalize text-black`}> {label} </small>
  );
}
export default InputLabel;
